export const normalizeCreditAnalysis = rawCreditAnalysis => {
  if (!rawCreditAnalysis) {
    return null
  }

  const creditAnalysis = {
    approvedCreditAmount: rawCreditAnalysis.application.approvedCredit.amount,
    installmentValue: rawCreditAnalysis.application.installment.value.amount,
    totalInstallments: rawCreditAnalysis.application.installment.maturity,
    totalLoanAmount: rawCreditAnalysis.application.netValues.amount,
    monthlyInterestRate:
      rawCreditAnalysis.application.interestRate.monthlyPercentage,
    yearlyInterestRate:
      rawCreditAnalysis.application.interestRate.yearlyPercentage,
    iofAmount: rawCreditAnalysis.application.iof.amount,
    registrationFeeAmount: rawCreditAnalysis.application.registrationFee.amount,
    monthlyCetRate: rawCreditAnalysis.application.cet.monthlyPercentage,
    yearlyCetRate: rawCreditAnalysis.application.cet.yearlyPercentage,
  }

  return creditAnalysis
}

export const normalizeCreditPayment = rawCreditPayment => {
  if (!rawCreditPayment) {
    return null
  }

  const creditPaid = {
    releasedAmount: rawCreditPayment.loan.paidValue.amount,
    installmentValue: rawCreditPayment.loan.installment.value.amount,
    totalInstallments: rawCreditPayment.loan.installment.maturity,
    totalLoanAmount: rawCreditPayment.loan.netValues.amount,
    monthlyInterestRate: rawCreditPayment.loan.interestRate.monthlyPercentage,
    iofAmount: rawCreditPayment.loan.iof.amount,
    registrationFeeAmount: rawCreditPayment.loan.registrationFee.amount,
    monthlyCetRate: rawCreditPayment.loan.cet.monthlyPercentage,
  }

  return creditPaid
}
